export interface PurchaseNotification {
  flagCode: string
  countryName: string
  location: string
  name: string
  initials: string
  time: string
}

export const purchaseNotifications: PurchaseNotification[] = [
  {
    flagCode: 'it',
    countryName: 'Italia',
    location: 'Milano, Italia',
    name: 'Giulia Ferrari',
    initials: 'GF',
    time: '5 minuti fa',
  },
  {
    flagCode: 'it',
    countryName: 'Italia',
    location: 'Roma, Italia',
    name: 'Marco Bianchi',
    initials: 'MB',
    time: '12 minuti fa',
  },
  {
    flagCode: 'es',
    countryName: 'Spagna',
    location: 'Madrid, Spagna',
    name: 'Elena Moretti',
    initials: 'EM',
    time: '18 minuti fa',
  },
  {
    flagCode: 'it',
    countryName: 'Italia',
    location: 'Bologna, Italia',
    name: 'Chiara Villa',
    initials: 'CV',
    time: '24 minuti fa',
  },
  {
    flagCode: 'fr',
    countryName: 'Francia',
    location: 'Lione, Francia',
    name: 'Antonio De Luca',
    initials: 'AD',
    time: '31 minuti fa',
  },
  {
    flagCode: 'it',
    countryName: 'Italia',
    location: 'Napoli, Italia',
    name: 'Federica Lombardi',
    initials: 'FL',
    time: '38 minuti fa',
  },
  {
    flagCode: 'de',
    countryName: 'Germania',
    location: 'Monaco, Germania',
    name: 'Luca Ricci',
    initials: 'LR',
    time: '46 minuti fa',
  },
  {
    flagCode: 'pt',
    countryName: 'Portogallo',
    location: 'Lisbona, Portogallo',
    name: 'Sara Greco',
    initials: 'SG',
    time: '52 minuti fa',
  },
]
